// This is where all the node_modules needed are put so webpack can create a vendor file
import 'toastr/build/toastr.min.css';
import 'travco-masterdata-select/dist/style.css';
import 'travco-date-range-picker/dist/style.css';
import 'travco-text-input/dist/style.css';
import 'travco-common-links/dist/style.css';
import 'travco-button-group/dist/style.css';
import 'travco-input-number/dist/style.css';
import 'react-tippy/dist/tippy.css';
import 'travco-header/dist/style.css';
import 'travco-footer/dist/style.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'travco-common-styles/dist/style.css';
import './styles/site.scss';
